import React from 'react';
import {ContextMenuProps} from './types';
import {useMediaQueries} from 'presentation/pages';
import {MobileContextMenu} from './MobileContextMenu';
import {DesktopContextMenu} from './DesktopContextMenu';

export function ContextMenu({
	anchorContextMenuEl,
	isMenuOpen,
	handleContextMenuClose,
	handleEdit,
	handleDelete,
	handleAssignToDependent,
	showAssignToDependent,
}: ContextMenuProps) {
	const {isMobile} = useMediaQueries();

	if (isMobile) {
		return (
			<MobileContextMenu
				anchorContextMenuEl={anchorContextMenuEl}
				isMenuOpen={isMenuOpen}
				handleContextMenuClose={handleContextMenuClose}
				handleEdit={handleEdit}
				handleDelete={handleDelete}
				handleAssignToDependent={handleAssignToDependent}
				showAssignToDependent={showAssignToDependent}
			/>
		);
	}

	return (
		<DesktopContextMenu
			anchorContextMenuEl={anchorContextMenuEl}
			isMenuOpen={isMenuOpen}
			handleContextMenuClose={handleContextMenuClose}
			handleEdit={handleEdit}
			handleDelete={handleDelete}
			handleAssignToDependent={handleAssignToDependent}
			showAssignToDependent={showAssignToDependent}
		/>
	);
}
